import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useRef } from "react";
import getUniqueValues from "../../../../../services/GetUniqueValues";
import styles from "./styles.module.scss";
import { setFilteredArchive } from "../../../../../redux/filter/filteredArchiveSlice";

const RenderFilters = ({ title, field, prefix }) => {
  const [selectedValues, setSelectedValues] = useState([]);
  const dispatch = useDispatch();
  const transcripts = useSelector(
    (state) => state.filteredArchiveSlice.transcripts
  );
  const originalTranscriptsRef = useRef();

  if (!originalTranscriptsRef.current && transcripts.length > 0) {
    originalTranscriptsRef.current = transcripts;
  }

  const handleCheckboxChange = (value, checked) => {
    if (checked) {
      setSelectedValues((prevValues) => [...prevValues, value]);
    } else {
      setSelectedValues((prevValues) => prevValues.filter((v) => v !== value));
    }
  };

  useEffect(() => {
    if (!originalTranscriptsRef.current) return;
    const filteredTranscripts = originalTranscriptsRef.current.filter(
      (transcript) => {
        if (field === "tags") {
          return (
            selectedValues.length === 0 ||
            transcript[field].some((tag) => selectedValues.includes(tag))
          );
        } else {
          return (
            selectedValues.length === 0 ||
            selectedValues.includes(transcript[field])
          );
        }
      }
    );
    dispatch(setFilteredArchive(filteredTranscripts));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedValues]);

  function toCapitalize(str) {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  const availableItems = transcripts ? field === "tags" ? ["Diplo Reporting Team", "Outsource"] : getUniqueValues(transcripts, field) : [];

  availableItems.sort((a, b) => {
    if (typeof a === "string" && typeof b === "string") {
      return a.localeCompare(b);
    }
    return a - b;
  });

  return (
    <fieldset className={styles.fieldset}>
      <legend>{title}</legend>
      {availableItems.length > 0 ? (
        availableItems.map((item, index) => (
          <div key={index}>
            <input
              type="checkbox"
              id={`${prefix}-${index}`}
              name={`${prefix}-${index}`}
              value={item}
              checked={selectedValues.includes(item)}
              onChange={(e) => handleCheckboxChange(item, e.target.checked)}
            />
            <label htmlFor={`${prefix}-${index}`}>{toCapitalize(item)}</label>
          </div>
        ))
      ) : (
        <p>There are no {title.toLowerCase()}.</p>
      )}
    </fieldset>
  );
};

export default RenderFilters;
